/**
 * Prefetch all asset paths injected during build
 * @see ../react-router.config.ts
 */
export const prefetchAssets = () => {
  // Import in batches to avoid choking users resources to death
  const BATCH_SIZE = 50;
  try {
    const chunkPaths = JSON.parse(document.getElementById('js-chunk-paths')?.textContent);
    for (let i = 0; i < chunkPaths.length; i += BATCH_SIZE) fetchAssetBatch(chunkPaths.slice(i, i + BATCH_SIZE));
  } catch {
    console.warn('Chunk prefetching disabled');
  }
};
const fetchAssetBatch = paths => defer(() => {
  // TODO: not use import maybe?
  for (const path of paths) void import(/* @vite-ignore */`${import.meta.env.BASE_URL}${path}`).catch(() => {});
});

/**
 * Defer evaluation of function till idle
 */
const defer = fn => {
  if (typeof window.requestIdleCallback === 'function') {
    requestIdleCallback(fn, {
      timeout: 30_000
    });
  } else {
    setTimeout(fn, 15_000);
  }
};